import { Component, OnInit } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router, ParamMap} from '@angular/router';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-workflow-detail',
  templateUrl: './workflow-detail.component.html',
  styleUrls: ['./workflow-detail.component.scss']
})
export class WorkflowDetailComponent implements OnInit {

  taskData$: Observable<any>;

  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.taskData$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => {
        const url = window.location.origin +  '/api/dm/workflow-detail';
        return this.http.get(url, {
          params: {
            client: params.get('client'),
            task: params.get('task')
          }});
      }));
  }
}
